import { IRender } from '../parseTreeToHtml.types';

export const strikethroughRender: IRender = (text): string => {
  if (!text) {
    return '';
  }

  return `<strike>${text}</strike>`;
};
